/* Bocock cart badge and the added to cart card.

   WHY THIS IS WRITTEN DEFENSIVELY. The header belongs to Prestige and its markup
   was never read, so nothing here assumes a class name. The cart link is found by
   the one thing true of every Shopify theme ever written, an anchor whose href
   points at /cart. If that is not found the script exits and the site behaves
   exactly as before.

   IT REUSES PRESTIGE'S OWN COUNTER IF THERE IS ONE. Before injecting anything it
   looks inside the cart link for an element whose text is nothing but digits,
   which is what a theme cart bubble looks like from the outside. If one is found
   it is adopted and restyled rather than duplicated, because two numbers on one
   icon is worse than none.

   THE CARD IS BUILT FROM THE /cart/add.js RESPONSE, never from the DOM. Shopify
   returns the line item it just created, with title, image, quantity and price
   already resolved. That is authoritative on the homepage, on a collection page
   and on a product page alike, and it removes every guess about where the product
   name and picture live in someone else's template.

   THE FLYING IMAGE WAS REMOVED 30 July 2026. It cloned a DOM image and animated
   between two measured rectangles, which is fragile on mobile and meaningless on a
   product page where the image is a gallery. It also only ever communicated where
   the thing went, never what went. The card says what.

   The count is read from /cart.js rather than tracked locally, because a local
   counter drifts the moment somebody removes an item in another tab. */
(function () {
  var link, badge, card, hideTimer;

  function findLink() {
    var cands = document.querySelectorAll('a[href$="/cart"], a[href*="/cart?"], a[href$="/cart/"]');
    var best = null;
    for (var i = 0; i < cands.length; i++) {
      var a = cands[i];
      if (a.closest('footer')) continue;
      var r = a.getBoundingClientRect();
      if (r.width === 0 && r.height === 0) continue;
      if (!best || r.top < best.getBoundingClientRect().top) best = a;
    }
    return best;
  }

  function findExistingCounter(a) {
    var kids = a.querySelectorAll('*');
    for (var i = 0; i < kids.length; i++) {
      var t = (kids[i].textContent || '').trim();
      if (t && /^\d{1,3}$/.test(t) && kids[i].children.length === 0) return kids[i];
    }
    return null;
  }

  function mount() {
    if (badge) return true;
    link = findLink();
    if (!link) return false;
    link.classList.add('bkcartlink');
    var existing = findExistingCounter(link);
    if (existing) { badge = existing; }
    else { badge = document.createElement('span'); badge.setAttribute('aria-hidden', 'true'); link.appendChild(badge); }
    badge.classList.add('bkcartcount');
    return true;
  }

  function paint(n, animate) {
    if (!mount()) return;
    badge.textContent = n;
    badge.classList.toggle('on', n > 0);
    badge.classList.toggle('pulse', n > 0);
    link.setAttribute('aria-label', n === 1 ? 'Cart, 1 item' : 'Cart, ' + n + ' items');
    if (animate && n > 0) {
      badge.classList.remove('tick'); void badge.offsetWidth; badge.classList.add('tick');
      link.classList.remove('bump'); void link.offsetWidth; link.classList.add('bump');
    }
  }

  function refresh(animate) {
    return fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) { paint(c.item_count || 0, animate); return c; })
      .catch(function () {});
  }

  function money(cents) {
    if (typeof cents !== 'number') return '';
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function buildCard() {
    if (card) return card;
    card = document.createElement('div');
    card.className = 'bkcard';
    card.setAttribute('role', 'status');
    card.setAttribute('aria-live', 'polite');
    card.style.position = 'fixed';
    card.innerHTML =
      '<button class="bkcard__x" type="button" aria-label="Dismiss">&times;</button>' +
      '<img class="bkcard__img" alt="" aria-hidden="true">' +
      '<div class="bkcard__b">' +
      '<div class="bkcard__eye"><svg viewBox="0 0 24 24" aria-hidden="true"><polyline points="20 6 9 17 4 12"/></svg>Added to cart</div>' +
      '<div class="bkcard__t"></div>' +
      '<div class="bkcard__m"></div>' +
      '<a class="bkcard__cta" href="/cart">View cart</a>' +
      '</div>';
    document.body.appendChild(card);
    card.querySelector('.bkcard__x').addEventListener('click', hide);
    return card;
  }

  function hide() {
    if (card) card.classList.remove('on');
    clearTimeout(hideTimer);
  }

  /* /cart/add.js returns the line item itself for a single add, and an object
     with an items array for a multi line add such as the kit. Handle both. */
  function show(body) {
    if (!body) return;
    var items = body.items && body.items.length ? body.items : [body];
    var first = items[0];
    if (!first || !first.title) return;

    var c = buildCard();
    var img = c.querySelector('.bkcard__img');
    if (first.image) { img.src = first.image.replace(/(\.[a-z]+)(\?|$)/i, '_120x$1$2'); img.style.display = ''; }
    else { img.removeAttribute('src'); img.style.display = 'none'; }

    c.querySelector('.bkcard__t').textContent = first.product_title || first.title;

    var qty = items.reduce(function (s, i) { return s + (i.quantity || 1); }, 0);
    var total = items.reduce(function (s, i) { return s + (i.final_line_price || i.line_price || 0); }, 0);
    var bits = [];
    if (items.length > 1) bits.push(items.length + ' items');
    else if (qty > 1) bits.push('Qty ' + qty);
    if (total) bits.push(money(total));
    c.querySelector('.bkcard__m').textContent = bits.join('  ·  ');

    c.classList.remove('on');
    void c.offsetWidth;
    c.classList.add('on');
    clearTimeout(hideTimer);
    hideTimer = setTimeout(hide, 4500);
  }

  document.addEventListener('bkcart:added', function (e) {
    show(e.detail && e.detail.body);
    setTimeout(function () { refresh(true); }, 220);
  });

  function boot() { mount(); refresh(false); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', function () { badge = null; boot(); });
})();
